/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Approveprospectlist_Title3Inputs */

const en_coinvestments_approveprospectlist_title3 = /** @type {(inputs: Coinvestments_Approveprospectlist_Title3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Approve Prospect List`)
};

/**
* | output |
* | --- |
* | "Approve Prospect List" |
*
* @param {Coinvestments_Approveprospectlist_Title3Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_approveprospectlist_title3 = /** @type {((inputs?: Coinvestments_Approveprospectlist_Title3Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Approveprospectlist_Title3Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_approveprospectlist_title3(inputs)
});
export { coinvestments_approveprospectlist_title3 as "coInvestments_approveProspectList_title" }